import React from 'react';

type ProductCardContentProps = {
  children: React.ReactNode;
};

export const VerticalProductCardContent = ({ children }: ProductCardContentProps) => {
  return (
    <div className="flex flex-col gap-2 w-full min-w-0 rounded-b-[8px]">
      <>{children}</>
    </div>
  );
};
